import { CommonResourceKey } from '../ResourceKeys';

export default interface MacroEvent {
    eventType: MacroEventType;
    keys?: string[];
    holdTimeMilliseconds?: number;
    isKeyLatch?: boolean;
    typedPhrase?: string;
    mouseMoveX?: number;
    mouseMoveY?: number;
    mouseMoveScroll?: number;
    joystickLeftMoveX?: number;
    joystickLeftMoveY?: number;
    joystickRightMoveX?: number;
    joystickRightMoveY?: number;
    deviceTypeCustomActionId?: string;
    deviceTypeId?: string;
    outputSpeech?: string;
    additionalInputContent?: string;
    isCustomToggle?: boolean;
    isCustomRelease?: boolean;
}

export interface MacroDisplayEvent {
    eventType: MacroEventType;
    keys?: string[];
    holdTimeMilliseconds?: number;
    isKeyLatch?: boolean;
    typedPhrase?: string;
    isMouseXNegative?: boolean;
    isMouseYNegative?: boolean;
    mouseMoveX?: number;
    mouseMoveY?: number;
    mouseMoveScroll?: number;
    joystickLeftMoveX?: number;
    joystickLeftMoveY?: number;
    joystickRightMoveX?: number;
    joystickRightMoveY?: number;
    deviceTypeCustomActionId?: string;
    deviceTypeId?: string;
    outputSpeech?: string;
    additionalInputContent?: string;
    isCustomToggle?: boolean;
    isCustomRelease?: boolean;
}

export type MacroEventType =
    | 'KeyPress'
    | 'Pause'
    | 'Type'
    | 'MouseMove'
    | 'JoysticksMove'
    | 'PlayAudio'
    | 'KeyRelease'
    | 'StopOutputs'
    | 'KeyToggle'
    | 'DeviceTypeCustomAction';

export interface MacroEventDisplayType {
    eventType: MacroEventType;
    displayName: CommonResourceKey;
}
export const macroEventTypes: MacroEventDisplayType[] = [
    {
        eventType: 'KeyPress',
        displayName: 'common:event.keyPress.title',
    },
    {
        eventType: 'KeyRelease',
        displayName: 'common:event.keyRelease.title',
    },
    {
        eventType: 'KeyToggle',
        displayName: 'common:event.keyToggle.title',
    },
    {
        eventType: 'Pause',
        displayName: 'common:event.pause.title',
    },
    {
        eventType: 'Type',
        displayName: 'common:event.type.title',
    },
    {
        eventType: 'MouseMove',
        displayName: 'common:event.mouseMove.title',
    },
    {
        eventType: 'JoysticksMove',
        displayName: 'common:event.joystickMove.title',
    },
    {
        eventType: 'PlayAudio',
        displayName: 'common:event.playAudio.title',
    },
    {
        eventType: 'StopOutputs',
        displayName: 'common:event.stopOutputs.title',
    },
    {
        eventType: 'DeviceTypeCustomAction',
        displayName: 'common:event.custom.title',
    },
];

export const hasHoldTime = (macroEvent: MacroEvent) => {
    return (
        (macroEvent.eventType == 'KeyPress' && macroEvent.holdTimeMilliseconds != null) ||
        macroEvent.eventType == 'Pause'
    );
};
